<div class="center-xy" [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden'}"
    *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light" data-testid="valve-control">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <img ngSrc="/assets/img/zone_icons/light/{{zones.selectedZone.description['styleIcon']}}.svg"
                     width="45" height="45" alt="" />
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
               {{ zones.getZoneName(zones.selectedZone) }}
            </p>
        </div>

        <div class="zone-control__content">
            <div class="zone-control__buttons-top">
                <div class="zone-control__close-button cursor-pointer bg-cancel bg-cancel__button"
                    data-testid="close-control"
                    (click)="zones.goHome()">
                    <img ngSrc="/assets/img/zone_icons/back_without_border.svg"
                        width="40" height="40" alt="" />
                </div>
            </div>
            <div class="zone-control__current-temp font-76">
                <p>{{ zones.selectedZone.tile.params.currentTemp | format:7 }}</p>
            </div>
            <div class="zone-control__set-temp font-45 bg-settings bg-settings--zone font-bold color-alarm">
                <p class="zone-control__set-temp-value">
                    {{ zones.selectedZone.tile.params.setTemp*10 | format:7 }}
                </p>
            </div>
            <div class="zone-control__mode-select zone-control__mode-select--valve font-bold">
                <div class="zone-control__select">
                    <div class="zone-control__select-icon"
                        (click)="zones.goToMenu(zones.selectedZone.tile, zones.selectedZone.tile.submenuElementId)">
                        <icon [iconName]="'menu-fitters'"
                             [iconSize]="80"
                             [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--white'">
                        </icon>
                        <icon [iconName]="'menu-fitters'"
                             [iconSize]="80"
                             [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--style fill-icon fill-icon--warning'">
                        </icon>
                    </div>
                    <p>{{ subtitle(388) }}</p>
                </div>
                <div class="zone-control__select zone-control__select--settings">
                    <div class="zone-control__select-icon"
                        (click)="zones.goToState('valve_info')">
                        <icon [iconName]="'settings'"
                             [iconSize]="80"
                             [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--white'">
                        </icon>
                        <icon [iconName]="'settings'"
                             [iconSize]="80"
                             [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--style fill-icon fill-icon--warning'">
                        </icon>
                    </div>
                    <p>{{ subtitle(3709) }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
